import { createIdSlice } from '../utils/action/createElementSlice';
export const TitleState = createIdSlice({
    elementName: 'title',
    initialState: {},
    reducers: {
        set: (_state, { payload: { data } }) => {
            return typeof data === 'string' ? { title: data } : data;
        },
        notifyDoubleClick: (state) => state,
    },
});
